import { Flex } from 'foundations-components/components/Flex';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import { productForSkuIdSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { SCREENS } from '../../v2/constants/tracking/Screens';
import { ADD_ON_CARD, APP } from '../../v2/constants/tracking/TrackingSources';
import { useAppSelector } from '../../reducers';
import { talkToSalesTypeSelector } from '../../selectors/PurchaseMotionSelectors';
import { isTTSPurchaseMotion } from '../../v2/utils/typeguards';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddOnCardCTAFallback = ({
  skuId,
  trackingSource
}) => {
  const {
    apiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const trackingData = {
    app: APP,
    screen: SCREENS.PRODUCTS_PLANS,
    uniqueId: `${trackingSource || ADD_ON_CARD}-${apiName}`
  };
  const purchaseMotion = useAppSelector(state => talkToSalesTypeSelector(state));
  if (!isTTSPurchaseMotion(purchaseMotion)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    children: /*#__PURE__*/_jsx(PurchaseMotionCTA, {
      apiName: apiName,
      purchaseMotion: purchaseMotion,
      location: 'MERCH_CARD',
      trackingData: trackingData,
      uiButtonProps: {
        use: 'primary',
        block: true
      }
    })
  });
};
export const AddOnCardPricingFallback = () => null;